import { create } from "zustand"
import { ModalState } from "./types"

const useModalStore = create<ModalState>((set: any, get: any) => ({
    open: "",
    lastOpen: "",
    payload: null,
    setOpen: (modalName: string, payload?: any) =>
        set({
            open: modalName,
            lastOpen: modalName,
            payload: payload ?? null,
        }),
    closeModal: () =>
        set({
            open: "",
            lastOpen: get().lastOpen,
            payload: null,
        }),
}))

export { useModalStore }


